import { Link } from "react-router-dom";
import { CITIES, COUNTRIES } from "@/cityConfig";

const citiesByCountry = Object.values(CITIES).reduce((acc, c) => {
  if (!acc[c.country]) acc[c.country] = [];
  acc[c.country].push(c);
  return acc;
}, {});

/**
 * Compact horizontal cities list for minimal/centered footers (blog pages).
 * Renders all 11 cities grouped by country with flags — for SEO internal linking.
 */
export default function FooterCitiesCompact({ lang = "ru" }) {
  const heading = lang === "tr" ? "Sehirler" : lang === "en" ? "Cities" : "Города";

  return (
    <div className="mt-8 pt-6 border-t border-white/10 text-left" data-testid="footer-cities-compact">
      <h4 className="text-sm font-bold text-pink-400 mb-4 text-center">{heading}</h4>
      <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-xs">
        {Object.values(COUNTRIES).map((country) => {
          const cities = citiesByCountry[country.slug] || [];
          if (cities.length === 0) return null;
          const countryLabel = lang === "tr" ? country.nameTr : lang === "en" ? country.nameEn : country.name;
          return (
            <div key={country.slug} className="flex items-center gap-1.5">
              <span aria-hidden="true" className="text-sm">{country.flag}</span>
              <span className="text-gray-400 font-semibold mr-1">{countryLabel}:</span>
              <div className="flex flex-wrap gap-x-2 gap-y-1">
                {cities.map((c) => (
                  <Link
                    key={c.slug}
                    to={`/${c.slug}${lang !== "ru" ? `?lang=${lang}` : ""}`}
                    className="text-gray-300 hover:text-pink-400 transition-colors"
                    data-testid={`footer-compact-city-${c.slug}`}
                  >
                    {lang === "tr" ? (c.nameTr || c.nameEn) : lang === "en" ? c.nameEn : c.name}
                  </Link>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
